import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import React, { Suspense } from "react";
import NuevaCotizacionWizard from "../../../views/CotizacionesEmpresariales/NuevaCotizacion/NuevaCotizacion";
import ListadoCotizaciones from "../../../views/CotizacionesEmpresariales/ListadoCotizaciones/ListadoCotizaciones";
import DetalleCotizacion from "../../../views/CotizacionesEmpresariales/DetallesCotizacion/DetalleCotizacion";
import GenerarTrazoCotizacion from "../../../views/CotizacionesEmpresariales/GenerarTrazoCotizacion/GenerarTrazoCotizacion";
import CotizacionModificacionRuta
    from "../../../views/CotizacionesEmpresariales/CotizacionModificacionRuta/CotizacionModificacionRuta";

const SkeletonFallback = () => <>skeleton</>;

const EditarCotizacionRoute = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const irAlListado = () => navigate('/cotizaciones/empresariales');
    return (
        <NuevaCotizacionWizard
            cotizacionId={id}
            onGuardado={irAlListado}
            onCancelar={irAlListado}
        />
    );
};

const Cotizaciones = () => {
    const navigate = useNavigate();
    const irAlListado = () => navigate('/cotizaciones/empresariales');

    const irADetalles = (id) => {
        navigate(`/cotizaciones/empresariales/detalle/${id}`);
    };

    return (
        <Routes>
            {/* ── Listado ── */}
            <Route
                path="/cotizaciones/empresariales"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <ListadoCotizaciones
                            onNuevaCotizacion={() => navigate('/cotizaciones/empresariales/nueva')}
                            onNuevaCotizacionEdicion={() => navigate('/cotizaciones/empresariales/nueva-modificacion')}
                            onVerDetalle={(id) => navigate(`/cotizaciones/empresariales/detalle/${id}`)}
                            onEditarCotizacion={(id) => navigate(`/cotizaciones/empresariales/editar/${id}`)}
                            onEditarCotizacionMod={(id) => navigate(`/cotizaciones/empresariales/modificacion/editar/${id}`)}
                        />
                    </Suspense>
                }
            />

            {/* ── Detalle ── */}
            <Route
                path="/cotizaciones/empresariales/detalle/:id"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <DetalleCotizacion />
                    </Suspense>
                }
            />

            {/* ── Nueva cotización ── */}
            <Route
                path="/cotizaciones/empresariales/nueva"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <NuevaCotizacionWizard
                            cotizacionId={null}
                            onGuardado={irADetalles}
                            onCancelar={irAlListado}
                        />
                    </Suspense>
                }
            />

            {/* ── Nueva cotización de Modificación ── */}
            <Route
                path="/cotizaciones/empresariales/nueva-modificacion"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <CotizacionModificacionRuta onGuardado={irADetalles}/>
                    </Suspense>
                }
            />

            {/* ── Editar cotización ── */}
            <Route
                path="/cotizaciones/empresariales/editar/:id"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <EditarCotizacionRoute />
                    </Suspense>
                }
            />

            {/* ── Nueva cotización de Modificación ── */}
            <Route
                path="/cotizaciones/empresariales/modificacion/editar/:id"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <CotizacionModificacionRuta modoEdicion={true} onGuardado={irADetalles}/>
                    </Suspense>
                }
            />

            {/*
             * ══════════════════════════════════════════════
             * TRAZOS — tres rutas, una sola vista
             *
             * /trazos/ (plural) → modo general
             * • nuevo → crea trazo para todas las estructuras
             * • editar → edita trazo general (todos los turnos)
             *
             * /trazo/ (singular) → modo individual
             * • editar → edita solo el trazo de una estructura
             *
             * El hook useEditorMode detecta el modo leyendo pathname:
             *    isEditing    = !!trazoId
             *    isIndividual = pathname.includes('/trazo/editar/')
             * ══════════════════════════════════════════════
             */}

            {/* Nuevo trazo — aplica a todas las estructuras */}
            <Route
                path="/cotizaciones/empresariales/:id/trazos/nuevo/:tipoLabel"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <GenerarTrazoCotizacion />
                    </Suspense>
                }
            />

            {/* Editar trazo general — modifica todos los turnos */}
            <Route
                path="/cotizaciones/empresariales/:id/trazos/editar/:trazoId/:tipoLabel"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <GenerarTrazoCotizacion />
                    </Suspense>
                }
            />

            {/* Editar trazo individual — solo el turno propio */}
            <Route
                path="/cotizaciones/empresariales/:id/trazo/editar/:trazoId/:tipoLabel"
                element={
                    <Suspense fallback={<SkeletonFallback />}>
                        <GenerarTrazoCotizacion />
                    </Suspense>
                }
            />
        </Routes>
    );
};

export default Cotizaciones;
